class AnchorTop {
    constructor() {
        document.addEventListener(
            "alpine:init",
            () => {
                Alpine.data("anchorTop", () => ({
                    goTop() {
                        window.scrollTo({ top: 0, behavior: "smooth" });
                    },
                }));
            },
            { once: true },
        );
    }
}

new AnchorTop();
